// Copyright © 2021 Move Closer

export * from './Modal.contracts'
export { default as CustomModal } from './Modal.vue'
